module.exports = __webpack_public_path__ + "img/chanpinshow.fa53c00d.png";